import { useContext } from 'react';

import { AppContext } from '../App';
import { KDSPermission } from '../libs';

// True when the user holds every permission named.
const useHasPermission = (...permissions: [KDSPermission, ...KDSPermission[]]): boolean => {
  const { user } = useContext(AppContext);
  return permissions.every((permission) => user.permissions?.includes(permission) === true);
};

export default useHasPermission;
